<template>
  <v-container fluid class="vehicle-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-vehicle`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-car</v-icon>
            Vehicle
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-loading`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Loading
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-mileage`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Mileage
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab-item
            :value="'tab-vehicle'"
          >
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Vehicle</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'vehiclecode')"
                        v-bind:value="initvalue.vehiclecode"
                        placeholder="Vehicle Code"
                        persistent-hint
                        single-line hint="Enter the vehicle code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'vehiclename')"
                        v-bind:value="initvalue.vehiclename"
                        placeholder="Vehicle Name"
                        persistent-hint
                        single-line hint="Enter the vehicle name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=vehicletypes
                        :value="initvalue.vehicletype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'vehicletype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the vehicle type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'vehiclestatus')"
                          v-bind:label="initvalue.vehiclestatus"
                          v-model="initvalue.vehiclestatus"
                          value="Active"
                          true-value="Active"
                          false-value="Inactive"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'vehiclemodel')"
                        v-bind:value="initvalue.vehiclemodel"
                        placeholder="Vehicle Model"
                        persistent-hint
                        single-line hint="Enter the vehicle model">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'vehiclelicense')"
                        v-bind:value="initvalue.vehiclelicense"
                        placeholder="License Num"
                        persistent-hint
                        single-line hint="Enter the license num">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="locationid"
                        v-bind:value="initvalue.locationid"
                        v-on:change="updateChangedValue($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-select
                        outlined
                        dense
                        persistent-hint
                        class="mb-4"
                        placeholder="Driver"
                        single-line
                        hint="Please choose the Driver"
                        :items="[{text: 'None', value: null},...users.filter(x=>x.userstatus=='Active' && x.locationid==locationid).map((x) => {return { text: x.username, value: x._id };})]"
                        v-bind:value="initvalue.driverid"
                        v-on:change="updateChangedValue($event, 'driverid')"
                      >
                      </v-select>
                      <v-select
                        outlined
                        dense
                        persistent-hint
                        class="mb-4"
                        placeholder="Loader"
                        single-line
                        hint="Please choose the Loader"
                        :items="users.filter(x=>x.userstatus=='Active' && x.locationid==locationid).map((x) => {return { text: x.username, value: x._id };})"
                        v-bind:value="initvalue.loaderid"
                        v-on:change="updateChangedValue($event, 'loaderid')"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/vehicle/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editVehicle()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-loading'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Loading Items</p>
                      </v-col>
                      <v-col md="6" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddItem = true; add_loading={}"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/vehicle/list"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        class="elevation-0"
                        sort-by="itemrank"
                        :headers="header_loading"
                        :items="data_loading"
                        :items-per-page="500"
                        :footer-props="footer"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteItem" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ items.length>0 && delete_loading.itemid ? items.find(x=>x._id == delete_loading.itemid)['itemname'] : ''  }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteItem = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteVehicleItem(delete_loading)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.itemid="{ item }">
                          {{ items.length>0 && item.itemid ? items.find(x=>x._id == item.itemid)['itemname'] : ''  }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editVehicleItemDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteVehicleItemDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-mileage'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Mileage</p>
                      </v-col>
                      <v-col md="6" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddMileage = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          to="/vehicle/list"
                          class="button-shadow mr-1"
                          color="success"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="mileagedate"
                        :headers="header_mileage"
                        :items="data_mileage"
                        :items-per-page="500"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteMileage" width="500">
                            <v-card>
                              <v-card-title> Delete this Mileage? </v-card-title>
                              <v-card-text>
                                {{ delete_mileage.discountname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteMileage = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteMileage(delete_mileage)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.vehicleid="{ item }">
                          {{ vehicles.length!==0 ? vehicles.find(i=>i._id == item.vehicleid)['vehiclename'] : ''  }}
                        </template>                    
                        <template v-slot:item.minAmount="{ item }">
                          <p class="two-line">{{ item.minAmount }} - {{ item.maxAmount  }}</p>
                        </template>
                        <template v-slot:item.discountvalue="{ item }">
                          <p class="two-line">{{ item.discounttype=='Rate' ? item.discountvalue*100 : item.discountvalue }} {{ item.discounttype=='Rate' ? '%' : ''  }}</p>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editMileageDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteMileageDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/vehicle/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div>
    <v-dialog
      v-model="isAddItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Loading Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_loading.itemrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col md="4">
                <v-select
                  class="mb-4"
                  :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                  v-model="add_loading.brandid"
                  placeholder="Brand"
                >
                </v-select>
              </v-col>
              <v-col md="6">
                <v-select
                  class="mb-4"
                  :items="items.filter(item=>item.brandid==add_loading.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                    })"
                  v-model="add_loading.itemid"
                  v-bind:error="errorindex == 11"
                  placeholder="Item"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_loading.itemquantity"
                  v-bind:error="errorindex == 12"
                  class="mb-4"
                  placeholder="Quantity"
                  type="number"
                  @input="calculateLoading"
                  single-line
                  hint="Qty"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  v-model="add_loading.itemweight"
                  class="mb-4"
                  placeholder="Weight (kg)"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Kg"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  v-model="add_loading.itemvolume"
                  class="mb-4"
                  placeholder="Volume (cbm)"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Cbm"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddItem = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addVehicleItem"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Loading Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  :value="edit_item.itemrank"
                  v-on:change="onChangeItem($event, 'itemrank')"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col md="4">
                <v-select
                  class="mb-4"
                  :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                  v-model="edit_item.brandid"
                  placeholder="Brand"
                >
                </v-select>
              </v-col>
              <v-col md="6">
                <v-select
                  class="mb-4"
                  :value="edit_item.itemid"
                  v-on:change="onChangeItem($event, 'itemid')"
                  :items="items.filter(item=>item.brandid==edit_item.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                  })"
                  v-bind:error="errorindex == 11"
                  placeholder="Item"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="edit_item.itemquantity"
                  :value="edit_item.itemquantity"
                  v-on:change="onChangeItem($event, 'itemquantity')"
                  v-bind:error="errorindex == 12"
                  class="mb-4"
                  placeholder="Quantity"
                  type="number"
                  @input="calculateLoading2"
                  single-line
                  hint="Qty"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  v-model="edit_item.itemweight"
                  :value="edit_item.itemweight"
                  class="mb-4"
                  placeholder="Weight (kg)"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Kg"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  v-model="edit_item.itemvolume"
                  :value="edit_item.itemvolume"
                  class="mb-4"
                  placeholder="Volume (cbm)"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Cbm"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditItem=false; edit_item={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editVehicleItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      filename: null,
      locationid: null,
      imageurl: undefined,
      isAddItem: false,
      isAddMileage: false,
      isDeleteItem: false,
      isDeleteMileage: false,
      isEditItem: false,
      isEditMileage: false,
      errorindex: null,
      initvalue: {},
      upload: {},
      photo: {},
      add_loading: {},
      edit_vehicle: {},
      edit_item: {},
      delete_loading: {},
      delete_mileage: {},
      change_loading: {},
      header_loading: [
        { text: "#", value: "itemrank", width: "10px" },
        { text: "Item", value: "itemid" },
        { text: "Quantity", value: "itemquantity" },
        { text: "Weight (kg)", value: "itemweight" },
        { text: "Volume (cbm)", value: "itemvolume" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      data_loading: [],
      vehicletypes: ['Box Truck', 'Car', 'Rickshaw', 'Van'],
      images: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
    }
  },
  computed: {
    ...mapState("Brand", ["brands"]),
    ...mapState("Item", ["items"]),
    ...mapState("Location", ["locations"]),
    ...mapState('Vehicle', ['isReceiving']),
    ...mapState("User", ["users"]),
  },
  methods: {
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions('Vehicle', ['insertVehicleItemRequest', 'deleteVehicleItemRequest', 'updateVehicleRequest','updateVehicleImageRequest', 'updateVehicleItemRequest', 'getVehiclesRequest']),
    ...mapActions("User", ["getUsersRequest"]),
    checkError1(){
      if(!this.add_loading.itemid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.add_loading.itemquantity){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async addVehicleItem(){
      if(!this.checkError1()) return;
      this.isAddItem = false;
      this.add_loading.vehicleid = this.initvalue._id;
      let result = await this.insertVehicleItemRequest(this.add_loading);
      this.data_loading.push(result);
      this.add_loading = {};
    },
    calculateLoading(){
      if(this.add_loading.itemid==null) return;
      let item = this.items.find(item=>item._id==this.add_loading.itemid);
      if(item==null) return;
      let w = item.itemweight;
      let v = item.itemvolume;
      this.add_loading.itemweight = (this.add_loading.itemquantity * w).toFixed(2);
      this.add_loading.itemvolume = (this.add_loading.itemquantity * v).toFixed(2);  
    },
    calculateLoading2(){
      if(this.edit_item.itemid==null) return;
      let item = this.items.find(item=>item._id==this.edit_item.itemid);
      if(item==null) return;
      let w = item.itemweight;
      let v = item.itemvolume;
      this.edit_item.itemweight = (this.edit_item.itemquantity * w).toFixed(2);
      this.edit_item.itemvolume = (this.edit_item.itemquantity * v).toFixed(2);
      this.change_loading.itemweight = this.edit_item.itemweight;
      this.change_loading.itemvolume = this.edit_item.itemvolume;
    },
    deleteVehicleItemDialog(item) {
      this.isDeleteItem = true;
      this.delete_loading = {_id: item._id,itemid: item.itemid};
    },
    async deleteVehicleItem(payload) {
      this.isDeleteItem = false;
      let response = await this.deleteVehicleItemRequest(payload);
      let index = this.data_loading.findIndex((trans) => trans._id == response._id);
      this.data_loading.splice(index, 1);
    },
    editVehicle() {
      this.vehicle._id = this.initvalue._id;
      this.updateVehicleRequest(this.vehicle);
      this.getVehiclesRequest();
      router.push('/vehicle/list');
    },
    async editVehicleItemRequest() {
      this.isEditItem = false;
      this.change_loading.add_loadingid = this.edit_item._id;
      let response = await this.updateVehicleItemRequest(this.change_loading);
      let index = this.data_loading.findIndex((x) => x._id == response._id);
      this.data_loading.splice(index, 1, response);
      this.edit_item = {};
    },
    editVehicleItemDialog(item) {
      console.log(item);
      let brandid = this.items.find(i=>i._id==item.itemid)['brandid'];
      this.edit_item = Object.assign({}, item);
      this.edit_item.brandid = brandid;
      this.change_loading = {};
      this.isEditItem = true;
      this.getVehiclesRequest();
    },
    editVehicleItemChanged(value, field){
      this.add_loading[field] = value;
    }, 
    editPhoto() {
      this.photo._id = this.initvalue._id;
      this.updateVehicleImageRequest(this.photo);
      this.getVehiclesRequest();
      router.push('/vehicle/list');
    },
    updateChangedValue(value, field){
      this.vehicle[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.vehicleimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onChangeItem(value, field){
      this.change_loading[field] = value;
    }, 
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.vehicleimage = file;
      this.upload.imagename = file.name;
    },
    uploadPhotos() {
      if(this.filename == null) return; 
      this.upload._id = this.initvalue._id;
      this.uploadItemImages(this.upload);
    },  
  },

  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'VehicleList' });
    this.locationid = this.initvalue.locationid;
    this.imageurl = this.initvalue.vehicleimage;
    this.images = this.initvalue.vehicleimages;
    this.data_loading = this.initvalue.items;
    
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
